/*
  KLOKI — PostHog produktová analytika.

  Autocapture (kliknutí), pageview, pageleave (scroll depth), heatmapy,
  vlastní událost add_to_cart se SPRÁVNOU variantou a nahrávání relací.
  (Nahrávání bylo ve fázi 1 vypnuté, zapnuto 16. 8. 2026 na žádost majitele.)

  GDPR: nic se nenačte ani neodešle, dokud návštěvník nedá souhlas s analytikou
  (Shopify Customer Privacy API, do kterého souhlas propisuje Pandectes).
  Při ODVOLÁNÍ souhlasu se sběr okamžitě zastaví a data se smažou.

  Konfiguraci (klíč + kontext obchodu) dodává theme.liquid jako window.KLOKI_PH.
*/
(function () {
  'use strict';

  var cfg = window.KLOKI_PH || {};
  var KEY = cfg.key || '';
  var HOST = cfg.host || 'https://eu.i.posthog.com';
  var ctx = cfg.ctx || {};
  var pageType = ctx.page_type || '';

  function log() {
    if (!cfg.debug || !window.console) return;
    console.log.apply(console, ['[kloki-posthog]'].concat(Array.prototype.slice.call(arguments)));
  }

  if (KEY.indexOf('phc_') !== 0) return;

  /* Zákaznické stránky netrackujeme vůbec: /account/reset/{id}/{token} a
     /account/activate/{id}/{token} mají v URL platný token (ten nesmí odejít
     třetí straně) a autocapture by z objednávek a adres posílal jména a adresy. */
  if (pageType.indexOf('customers/') === 0) {
    log('zákaznická stránka — netrackuje se');
    return;
  }

  /* ?ph_debug=1 = ruční test na preview: zapne logování a povolí běh i na
     nepublikovaném theme. Události z něj jdou do stejného projektu, ale nesou
     kloki_theme_role != 'main', takže se dají v PostHogu odfiltrovat. */
  var debugMode = /[?&]ph_debug=1(&|$)/.test(window.location.search);
  if (debugMode) cfg.debug = true;

  /* Theme editor a nepublikované (testovací) theme by jinak míchaly data do produkce. */
  if (window.Shopify && window.Shopify.designMode) {
    log('design mode — netrackuje se');
    return;
  }
  var themeRole = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || '';
  if (themeRole && themeRole !== 'main' && !debugMode) {
    log('theme role ' + themeRole + ' — netrackuje se (test povolíš přes ?ph_debug=1)');
    return;
  }

  var started = false;

  /* Oficiální PostHog stub. Samotné array.js se stahuje až uvnitř posthog.init(),
     takže před souhlasem neodejde žádný požadavek na PostHog. */
  !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagResult reloadFeatureFlags group updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures getActiveMatchingSurveys getSurveys getNextSurveyStep onSessionId".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);

  /* Kontext, který platí pro celý obchod → register (drží se napříč stránkami). */
  var STABLE_KEYS = ['market', 'locale', 'country', 'currency'];

  function props(wantStable) {
    var out = {};
    for (var k in ctx) {
      if (!Object.prototype.hasOwnProperty.call(ctx, k)) continue;
      var isStable = STABLE_KEYS.indexOf(k) !== -1;
      if (isStable !== wantStable) continue;
      if (ctx[k] === null || ctx[k] === '') continue;
      out['kloki_' + k] = ctx[k];
    }
    return out;
  }

  /* Kontext vázaný na TUTO stránku (product_handle, template…) se přes register()
     posílat nesmí — přilepil by se natrvalo i na všechny další stránky. Lepíme ho
     proto ke každé události až v before_send, kde platí jen pro tento pageload. */
  function pageProps() { return props(false); }
  function stableProps() { return props(true); }

  function scrubUrl(v) {
    if (typeof v !== 'string') return v;
    return v.replace(/\/account\/(reset|activate)\/[^?#\s]+/g, '/account/$1/[redacted]');
  }

  function start() {
    if (started) return;
    started = true;
    log('souhlas udělen, startuji');

    window.posthog.init(KEY, {
      api_host: HOST,
      autocapture: true,
      capture_pageview: true,
      capture_pageleave: true,
      capture_heatmaps: true,
      /* Nahrávání relací. Aby se skutečně nahrávalo, musí platit VŠECHNY podmínky
         (ověřeno v posthog-js: startIfEnabled kontroluje `enabled` z remote configu
         && !disable_session_recording && !consent.isOptedOut()):
           1. tenhle přepínač na false,
           2. „Record user sessions“ zapnuté v projektu (Settings → Session replay),
           3. návštěvník dal souhlas s analytikou (řeší applyConsent níže),
           4. běžíme na publikovaném theme, ne v editoru.
         Odvolání souhlasu nahrávání zastaví samo — opt_out_capturing() je jedna
         z podmínek výše, nemusí se řešit zvlášť. */
      disable_session_recording: false,
      session_recording: {
        /* Výchozí chování posthog-js: maskuje vstupy, ale NE text stránky.
           Držíme to explicitně, ať se to nezmění s verzí knihovny. Cokoli dalšího
           lze schovat atributem data-ph-mask="" přímo v šabloně. */
        maskAllInputs: true,
        maskTextSelector: '[data-ph-mask]'
      },
      person_profiles: 'identified_only',
      persistence: 'localStorage+cookie',

      /* Piny proti vzdálené konfiguraci: bez nich může PostHog UI kdykoli zapnout
         další sběr a dotáhnout na web další skripty. Web je už teď těžký, tak si
         to držíme v kódu. Zapínat vědomě, ne omylem z UI. */
      disable_surveys: true,
      capture_exceptions: false,
      capture_dead_clicks: false,
      capture_performance: false,
      advanced_disable_feature_flags: true,

      before_send: function (event) {
        if (!event) return event;
        event.properties = event.properties || {};

        var p = pageProps();
        for (var k in p) {
          if (!(k in event.properties)) event.properties[k] = p[k];
        }

        /* Pojistka pro případ, že by se sem zákaznická stránka přece jen dostala
           (jiný page_type, změna URL schématu) — token v URL nesmí odejít. */
        var urlKeys = ['$current_url', '$pathname', '$referrer', '$initial_current_url', '$initial_referrer'];
        for (var i = 0; i < urlKeys.length; i++) {
          if (event.properties[urlKeys[i]]) {
            event.properties[urlKeys[i]] = scrubUrl(event.properties[urlKeys[i]]);
          }
        }
        return event;
      },

      loaded: function (ph) {
        /* opt_out si PostHog pamatuje v cookie. Bez tohohle by se po dřívějším
           odvolání souhlasu tracking už nikdy tiše nerozjel. */
        try {
          if (ph.has_opted_out_capturing && ph.has_opted_out_capturing()) ph.opt_in_capturing();
        } catch (e) {}

        var s = stableProps();
        /* Aby šly testovací události z nepublikovaného theme v PostHogu odfiltrovat. */
        if (themeRole) s.kloki_theme_role = themeRole;
        if (Object.keys(s).length) ph.register(s);
        log('inicializováno', s);
      }
    });

    bindAddToCart();
  }

  /* Které zboží šlo do košíku. Statické data-ph atributy na tlačítku by u varianty
     lhaly (theme po přepnutí barvy tlačítko nepřekresluje), proto čteme aktuální
     variantu z formuláře až při odeslání. */
  function bindAddToCart() {
    document.addEventListener('submit', function (e) {
      try {
        var form = e.target;
        if (!form || !form.getAttribute) return;
        var action = form.getAttribute('action') || '';
        if (action.indexOf('/cart/add') === -1) return;

        var idEl = form.querySelector('[name="id"]');
        var qtyEl = form.querySelector('[name="quantity"]');
        var props = {};
        if (idEl && idEl.value) props.variant_id = String(idEl.value);
        if (qtyEl && qtyEl.value) props.quantity = Number(qtyEl.value) || 1;
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn && submitBtn.getAttribute('data-ph-capture-attribute-preorder') === 'true') {
          props.preorder = true;
        }

        window.posthog.capture('add_to_cart', props);
      } catch (err) {
        log('add_to_cart chyba', err);
      }
    }, true);
  }

  function analyticsAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed());
    } catch (e) {
      return false;
    }
  }

  function applyConsent() {
    if (analyticsAllowed()) {
      if (started) {
        try { window.posthog.opt_in_capturing(); } catch (e) {}
        log('souhlas obnoven');
      } else {
        start();
      }
    } else if (started) {
      /* Odvolání souhlasu musí sběr zastavit hned, ne až při dalším načtení stránky.
         opt_out_capturing() zastaví sběr i zápis do úložiště, reset(true) zahodí
         distinct_id a nasbírané properties. */
      try {
        window.posthog.opt_out_capturing();
        window.posthog.reset(true);
      } catch (e) {}
      log('souhlas odvolán, zastavuji a mažu');
    }
  }

  function watchConsent() {
    applyConsent();
    document.addEventListener('visitorConsentCollected', applyConsent);
  }

  window.Shopify = window.Shopify || {};

  if (typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error) {
        log('Customer Privacy API se nenačetlo', error);
        return;
      }
      watchConsent();
    });
  } else {
    // Bez Privacy API souhlas neumíme ověřit → raději netrackujeme.
    log('Shopify.loadFeatures není k dispozici — PostHog se nespustí');
  }
})();
